import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { DataCacheProvider } from '@/contexts/cache';
import { AppContextProvider } from '@/contexts/app';
import { FormContextProvider } from '@/contexts/form';
import { UserContextProvider } from '@/contexts/user';
import { KeycloakProvider } from '@/contexts/keycloak';
import { ThemeContextProvider } from '@/contexts/theme';
import { LanguageContextProvider } from '@/contexts/language';
import { AnalyticsContextProvider } from '@/contexts/analytics';

import { App } from '../App';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      gcTime: 10000,
    },
    queries: {
      gcTime: 30000,
      retry: (failureCount, error) => {
        if (error.status === 500) return false;
        return failureCount < 3;
      },
    },
  },
});

export default function Index() {
  return (
    <DataCacheProvider>
      <AppContextProvider>
        <FormContextProvider>
          <AnalyticsContextProvider>
            <UserContextProvider>
              <KeycloakProvider>
                <ThemeContextProvider>
                  <LanguageContextProvider>
                    <QueryClientProvider client={queryClient}>
                      <App />
                    </QueryClientProvider>
                  </LanguageContextProvider>
                </ThemeContextProvider>
              </KeycloakProvider>
            </UserContextProvider>
          </AnalyticsContextProvider>
        </FormContextProvider>
      </AppContextProvider>
    </DataCacheProvider>
  );
}
